export default __webpack_public_path__ + "static/aircrack-412b420192f02780de262358ee23718a.png";